export default "__VITE_ASSET__CSqvsaZI__"